/**
 * Tema estacional vigente de la sucursal seleccionada.
 * No aplica estilos: solo expone la clave/config para packs visuales futuros.
 */

import { useEffect, useState } from "react";
import { obtenerTemaEstacionalActivo } from "../services/temasEstacionalesService";

export function useTemaEstacionalCarta(sucursalId) {
  const [temaEstacional, setTemaEstacional] = useState(null);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    let cancelado = false;

    async function cargar() {
      if (!sucursalId) {
        setTemaEstacional(null);
        return;
      }

      setCargando(true);

      try {
        const tema = await obtenerTemaEstacionalActivo(sucursalId);
        if (!cancelado) {
          setTemaEstacional(tema);
        }
      } catch (error) {
        console.error("Error cargando tema estacional de la carta:", error);
        if (!cancelado) {
          setTemaEstacional(null);
        }
      } finally {
        if (!cancelado) {
          setCargando(false);
        }
      }
    }

    cargar();

    return () => {
      cancelado = true;
    };
  }, [sucursalId]);

  return { temaEstacional, cargando };
}
